import { render } from "./NewReceiverPairing.vue?vue&type=template&id=7299cf8f&scoped=true&ts=true"
import script from "./NewReceiverPairing.vue?vue&type=script&lang=ts"
export * from "./NewReceiverPairing.vue?vue&type=script&lang=ts"

import "./NewReceiverPairing.vue?vue&type=style&index=0&id=7299cf8f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7299cf8f"]])

export default __exports__